import { createApi } from "@reduxjs/toolkit/query/react";
import customFetchBase from "services/principal/customFetchBase";

export const reconocimientoApi = createApi({
  reducerPath: "reconocimientoApi",
  baseQuery: customFetchBase,
  tagTypes: ["Reconocimiento"],
  endpoints: (builder) => ({
    getReconocimientos: builder.query({
      query: () => ({
        url: "/v1/api/reconocimiento/",
        method: "GET",
      }),
      providesTags: (result) =>
        Array.isArray(result)
          ? [
              ...result.map(({ id }) => ({
                type: "Reconocimiento",
                id,
              })),
              { type: "Reconocimiento", id: "LIST" },
            ]
          : [{ type: "Reconocimiento", id: "LIST" }],
    }),
    getReconocimiento: builder.query({
      query: (id) => ({
        url: `/v1/api/reconocimiento/${id}/`,
        method: "GET",
      }),
      providesTags: (result, error, id) => [{ type: "Reconocimiento", id }],
    }),
  }),
});

export const {
  useGetReconocimientosQuery,
  useGetReconocimientoQuery,
} = reconocimientoApi;
